import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Iban } from "../../interfaces/Iban";
import { IbanDialogComponent } from "./iban-dialog";

@Component({
  selector: "iban-input",
  templateUrl: "iban-input.html",
  standalone: false,
})
export class IbanInputComponent {
  @Input() pays: string = "";
  @Input() banque: string = "";
  @Input() guichet: string = "";
  @Input() compte: string = "";
  @Input() cle: string = "";
  @Input() disabled: boolean = false;

  @Output() paysChange = new EventEmitter<string>();
  @Output() banqueChange = new EventEmitter<string>();
  @Output() guichetChange = new EventEmitter<string>();
  @Output() compteChange = new EventEmitter<string>();
  @Output() cleChange = new EventEmitter<string>();
  @Output() ibanChange = new EventEmitter<Iban>();

  constructor(private _dialog: MatDialog) {}

  hasValue(): boolean {
    return !!(
      this.pays == "" ||
      this.banque == "" ||
      this.guichet == "" ||
      this.compte == "" ||
      this.cle == ""
    );
  }

  formatIban(): string {
    const parts = [
      this.pays,
      this.banque,
      this.guichet,
      this.compte,
      this.cle,
    ].filter((p) => p);

    return parts.join(" ");
  }

  openEditDialog(): void {
    const dialogRef = this._dialog.open(IbanDialogComponent, {
      width: "800px",
      data: {
        pays: this.pays,
        banque: this.banque,
        guichet: this.guichet,
        compte: this.compte,
        cle: this.cle,
      },
    });

    dialogRef.afterClosed().subscribe((result: Iban) => {
      if (result) {
        this.pays = result.pays;
        this.banque = result.banque;
        this.guichet = result.guichet;
        this.compte = result.compte;
        this.cle = result.cle;

        this.emitChanges();
      }
    });
  }

  clear(): void {
    this.pays = "";
    this.banque = "";
    this.guichet = "";
    this.compte = "";
    this.cle = "";

    this.emitChanges();
  }

  private emitChanges(): void {
    this.paysChange.emit(this.pays);
    this.banqueChange.emit(this.banque);
    this.guichetChange.emit(this.guichet);
    this.compteChange.emit(this.compte);
    this.cleChange.emit(this.cle);

    this.ibanChange.emit({
      pays: this.pays,
      banque: this.banque,
      guichet: this.guichet,
      compte: this.compte,
      cle: this.cle,
    });
  }
}
